import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {Router} from '@angular/router';
import 'rxjs/add/operator/do';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse, HttpXsrfTokenExtractor
} from '@angular/common/http';
import {OperatingStandardService} from './operating-standard.service';
import 'rxjs/add/operator/map';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from './auth.service';
import {HttpStatus} from '../shared.constants/all-constants';

const XSRF_HEADER = 'X-XSRF-TOKEN';
const NOTIFICATION_HEADER = 'NOTIFY-ME';
const AUTH_SESSION_PATH = '/auth/session';
const INDEX_NOT_FOUND = -1;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router,
              private cookie: CookieService,
              private tokenExtractor: HttpXsrfTokenExtractor,
              private injector: Injector) {
  }

  intercept(request: HttpRequest<Object>, next: HttpHandler): Observable<HttpEvent<Object>> {
    const service = this.injector.get(OperatingStandardService);
    return next.handle(this.withXsrfToken(request))
      .do(event => this.updateNotificationCount(event, service))
      .catch(error => this.handleError(request, error));
  }

  private withXsrfToken(request: HttpRequest<Object>): HttpRequest<Object> {
    const token = this.tokenExtractor.getToken() as string;
    if (token === null || request.headers.has(XSRF_HEADER)) {
      return request;
    }
    return request.clone({ headers: request.headers.set(XSRF_HEADER, token) });
  }

  private updateNotificationCount(event: HttpEvent<Object>, service: OperatingStandardService): void {
    if (!(event instanceof HttpResponse) || !event.headers.get(NOTIFICATION_HEADER)) {
      return;
    }
    service.notificationCountManager(event.headers.get(NOTIFICATION_HEADER));
  }

  private handleError(request: HttpRequest<Object>, error: HttpErrorResponse): Observable<HttpEvent<Object>> {
    if (error instanceof HttpErrorResponse && this.shouldClearClientSession(error)) {
      const authService = this.injector.get(AuthService, null);
      if (this.shouldRememberExpiredSession(request, error, authService)) {
        authService.rememberSessionExpired();
      }
      this.clearClientSession(authService);
    }
    return Observable.throw(error);
  }

  private shouldClearClientSession(error: HttpErrorResponse): boolean {
    return error.status === HttpStatus.UNAUTHORIZED;
  }

  private shouldRememberExpiredSession(
    request: HttpRequest<Object>, error: HttpErrorResponse, authService: AuthService
  ): boolean {
    return error.status === HttpStatus.UNAUTHORIZED
      && request.url.indexOf(AUTH_SESSION_PATH) === INDEX_NOT_FOUND
      && authService !== null
      && authService.isAuthenticated();
  }

  private clearClientSession(authService: AuthService): void {
    if (authService !== null) {
      authService.clearClientSession();
    } else {
      this.clearClientSessionFallback();
    }
    this.router.navigate(['signin']);
  }

  private clearClientSessionFallback(): void {
    const lang = localStorage.getItem('lang');
    localStorage.clear();
    if (lang !== null) {
      localStorage.setItem('lang', lang);
    }
    if (this.cookie && this.cookie.deleteAll) {
      this.cookie.deleteAll();
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/error-interceptor.service.ts